import React, { useState } from "react";
import ProfileForm from "./ProfileForm";
import makeRequest from "../utilities/makeRequest";
import authHeaders from "../utilities/authHeaders";
import notification from "../utilities/notification";

const ProfileContainer = ({
  closeModalAfterUpload,
  currentUser,
  errors,
  logout,
  posts,
  previewAvatar,
  previewMessage,
  setCurrentUserAvatar,
  setErrors,
  setPosts,
  setPreviewAvatar,
  setPreviewMessage,
}) => {
  const [image, setImage] = useState("");
  const [label, setLabel] = useState("Select a file");

  const onChangeImage = (event) => {
    setPreviewMessage(true);
    const imageSize = event.target.files[0].size;
    const maxImageSize = 5 * 1024 * 1024;
    if (imageSize > maxImageSize) {
      alert("File exceeds 5MB limit");
    } else {
      setImage(event.target.value);
      setPreviewAvatar(URL.createObjectURL(event.target.files[0]));
      setLabel("1 file selected");
    }
  };

  const url = `${process.env.REACT_APP_HOST}/api/v1/users/register`;

  const handleSubmit = (event) => {
    event.preventDefault();

    const method = "PATCH";
    const fileInput = document.querySelector('input[type="file"]');
    const formData = new FormData();
    formData.append("user[avatar]", fileInput.files[0], image);

    makeRequest(url, method, formData, authHeaders())
      .then((response) => {
        if (response.ok) {
          response.json().then((response) => {
            const newAvatar = response.data.attributes.avatar;
            setCurrentUserAvatar(newAvatar);
            closeModalAfterUpload();
            notification("Profile updated!", "success", 3000);
          });
        } else {
          response.json().then((data) => {
            setErrors(data);
            setImage("");
            setCurrentUserAvatar(null);
            setLabel("Select a file");
          });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const handleDeleteAccount = () => {
    if (
      window.confirm(
        "Are you sure you want to delete your account and all your posts? This action cannot be undone"
      )
    ) {
      deleteAccount();
    } else {
      notification("Account not deleted", "danger", 3000);
    }
  };

  const deleteAccount = () => {
    fetch(url, {
      method: "DELETE",
      headers: authHeaders(),
    })
      .then((response) => {
        if (response.ok) {
          const newPosts = posts.filter(
            (post) => post.attributes.user.name !== currentUser
          );
          setPosts(newPosts);
          logout();
          closeModalAfterUpload();
          notification("Account deleted", "success", 3000);
        } else {
          notification("Could not delete account", "danger", 3000);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  return (
    <ProfileForm
      closeModal={closeModalAfterUpload}
      errors={errors}
      handleDeleteAccount={handleDeleteAccount}
      handleSubmit={handleSubmit}
      image={image}
      label={label}
      onChangeImage={onChangeImage}
      previewAvatar={previewAvatar}
      previewMessage={previewMessage}
      setErrors={setErrors}
      setPreviewMessage={setPreviewMessage}
    />
  );
};

export default ProfileContainer;
